/**
 * Product Metafield Options Component
 * Handles interactive product option selection
 */

class ProductMetafieldOptions {
  constructor() {
    this.selectors = {
      container: '.product-metafield-options',
      item: '.product-metafield-options__item',
      compareLink: '.product-metafield-options__compare-link'
    };
    
    this.init();
  }
  
  init() {
    this.bindEvents();
    this.handleCurrentProduct();
  }
  
  bindEvents() {
    const container = document.querySelector(this.selectors.container);
    if (!container) return;
    
    // 为所有选项项添加点击事件
    const items = container.querySelectorAll(this.selectors.item);
    items.forEach(item => {
      item.addEventListener('click', this.handleItemClick.bind(this));
      item.addEventListener('keydown', this.handleKeyDown.bind(this));
    });
    
    // 为比较链接添加点击事件
    const compareLinks = container.querySelectorAll(this.selectors.compareLink);
    compareLinks.forEach(link => {
      link.addEventListener('click', this.handleCompareLinkClick.bind(this));
    });
  }
  
  handleItemClick(event) {
    const item = event.currentTarget;
    const link = item.querySelector('a');
    
    // 如果点击的是当前产品，不做任何操作
    if (item.classList.contains('product-metafield-options__item--current')) {
      event.preventDefault();
      return;
    }
    
    // 如果有链接，跳转到产品页面
    if (link) {
      window.location.href = link.href;
    }
  }
  
  handleKeyDown(event) {
    // 支持键盘导航
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.handleItemClick(event);
    }
  }
  
  handleCompareLinkClick(event) {
    event.stopPropagation(); // 阻止事件冒泡到父元素
    
    // 这里可以添加比较功能的逻辑
    // 例如：打开比较页面、添加到比较列表等
    console.log('Compare link clicked');
  }
  
  handleCurrentProduct() {
    const currentItem = document.querySelector(`${this.selectors.item}--current`);
    if (currentItem) {
      // 为当前产品添加额外的样式或功能
      currentItem.setAttribute('aria-current', 'page');
      currentItem.setAttribute('tabindex', '0');
    }
  }
  
  // 添加产品到比较列表的方法
  addToCompare(productId) {
    // 这里可以集成主题的比较功能
    if (typeof window.theme !== 'undefined' && window.theme.compare) {
      window.theme.compare.add(productId);
    }
  }
  
  // 显示加载状态
  showLoading() {
    const container = document.querySelector(this.selectors.container);
    if (container) {
      container.classList.add('skeleton-loading');
    }
  }
  
  // 隐藏加载状态
  hideLoading() {
    const container = document.querySelector(this.selectors.container);
    if (container) {
      container.classList.remove('skeleton-loading');
    }
  }
}

// 当DOM加载完成时初始化
document.addEventListener('DOMContentLoaded', () => {
  new ProductMetafieldOptions();
});

// 如果主题有特定的初始化方式，也可以这样做
if (typeof window.theme !== 'undefined') {
  window.theme.ProductMetafieldOptions = ProductMetafieldOptions;
}

// Listen for product option changes (example usage)
document.addEventListener('productOptionChanged', (event) => {
  console.log('Product option changed:', event.detail);
  
  // You can add custom logic here, such as:
  // - Analytics tracking
  // - Custom animations
  // - Third-party integrations
  // - User behavior tracking
}); 